<p-toast></p-toast>

<form [formGroup]="form" (ngSubmit)="onSave()" class="p-fluid">

  <hr class="mt-0 mb-4" />

  <div class="p-4">

    <!-- Wrapper to match Currency Exchange spacing -->
    <div class="flex flex-column gap-2 mb-4">
      <!-- Group / Role -->
      <div class="field grid">
        <label for="role" class="col-12 md:col-4 font-medium">
          {{ 'layout.configurations.staffedRoles.addStaffedRole.group' | translate }}
          <span class="text-red-500">*</span>
        </label>

        <div class="col-12 md:col-8">

          <!-- ADD MODE -->
          <p-dropdown
            *ngIf="!isEditMode"
            id="role"
            formControlName="role"
            [options]="filteredRoleOptionsObj"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'layout.configurations.staffedRoles.addStaffedRole.group' | translate"
            [filter]="true"
            [showClear]="true"
            filterBy="searchKey"
            (onFilter)="onRoleSearchInput($event)"
            appendTo="body"
            styleClass="w-full"
            [ngClass]="{ 'p-invalid': isInvalid('role') }">
          </p-dropdown>

          <!-- EDIT MODE -->
          <input
            *ngIf="isEditMode"
            id="role"
            formControlName="role"
            type="text"
            pInputText
            class="w-full"
            [placeholder]="'layout.configurations.staffedRoles.addStaffedRole.group' | translate"
            [ngClass]="{ 'p-invalid': isInvalid('role') }" />

          <!-- Validation Messages -->
          <small
            class="text-red-500"
            *ngIf="form.get('role')?.hasError('required') && form.get('role')?.touched">
            {{ errorMessages.requiredGroup | translate }}
          </small>

          <small
            class="text-red-500"
            *ngIf="form.get('role')?.hasError('pattern') && form.get('role')?.touched">
            {{ errorMessages.invalidGroup | translate }}
          </small>

          <small
            class="text-red-500"
            *ngIf="formErrors && getErrorMessage('role') !== ''">
            {{ getErrorMessage('role') | translate }}
          </small>
        </div>
      </div>
      <!-- Fiscal Year -->
      <div class="field grid">
        <label for="fiscalYear" class="col-12 md:col-4 font-medium">
          {{ 'layout.configurations.staffedRoles.addStaffedRole.fiscalYear' | translate }}
          <span class="text-red-500">*</span>
        </label>

        <div class="col-12 md:col-8">
          <p-dropdown
            id="fiscalYear"
            formControlName="fiscalYear"
            [options]="fiscalYearOptions"
            appendTo="body"
            styleClass="w-full"
            [placeholder]="'layout.configurations.staffedRoles.addStaffedRole.fiscalYear' | translate"
            [ngClass]="{ 'p-invalid': isInvalid('fiscalYear') }">
          </p-dropdown>

          <small
            class="text-red-500"
            *ngIf="form.get('fiscalYear')?.hasError('required') && form.get('fiscalYear')?.touched">
            {{ 'layout.configurations.staffedRoles.addStaffedRole.fiscalYearRequired' | translate }}
          </small>
        </div>
      </div>

      <div class="field grid align-items-center">
        <label for="rateEuro" class="col-12 md:col-4 font-medium">
          EUR
          <span class="text-red-500">*</span>
        </label>

        <div class="col-12 md:col-8">
          <input
            id="rateEuro"
            pInputText
            type="number"
            step="0.01"
            class="w-full"
            formControlName="rateEuro"
            [placeholder]="'layout.configurations.staffedRoles.addStaffedRole.enterRate' | translate"
            [ngClass]="{ 'p-invalid': isInvalid('rateEuro') }" />

          <small
            class="text-red-500"
            *ngIf="form.get('rateEuro')?.hasError('required') && form.get('rateEuro')?.touched">
            {{ errorMessages.requiredEuro | translate }}
          </small>

          <small
            class="text-red-500"
            *ngIf="form.get('rateEuro')?.hasError('min') && form.get('rateEuro')?.touched">
            {{ errorMessages.invalidRate | translate }}
          </small>
        </div>
      </div>
      <!-- Dynamic Currency Rates -->
      <div class="mt-4">
        <div
          *ngFor="let currency of orderedCurrencies"
          class="field grid align-items-center">

          <label class="col-12 md:col-4 font-medium">
            {{ currency }}
          </label>

          <div class="col-12 md:col-8">
            <input
              pInputText
              type="number"
              step="0.01"
              class="w-full"
              [id]="'rate' + currency.charAt(0).toUpperCase() + currency.slice(1).toLowerCase()"
              [formControlName]="'rate' + currency.charAt(0).toUpperCase() + currency.slice(1).toLowerCase()"
              [placeholder]="'layout.configurations.staffedRoles.addStaffedRole.enterRate' | translate"
              [ngClass]="{
                'p-invalid':
                  isInvalid('rate' + currency.charAt(0).toUpperCase() + currency.slice(1).toLowerCase())
              }" />
          </div>

        </div>

      </div>

    </div>
  </div>
  <!-- Buttons -->
  <div class="flex justify-content-end gap-2 px-4 pb-4">

    <p-button
      type="submit"
      icon="pi pi-check"
      [label]="
        (isEditMode
          ? 'layout.configurations.staffedRoles.editStaffedRole.save'
          : 'layout.configurations.staffedRoles.addStaffedRole.save') | translate">
    </p-button>

    <p-button
      icon="pi pi-times"
      severity="danger"
      class="p-button-outlined"
      type="button"
      (onClick)="onCancel()"
      [label]="'layout.configurations.staffedRoles.addStaffedRole.cancel' | translate">
    </p-button>

  </div>

</form>